export const opentLink = (id) => {
  window.location.href = '/modelviewer/' + btoa(id);
  // window.location.href = "/modelviewer/" + (id);
};
